import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CustomMaterialModule } from "./core/material.module";
import { CurrencyPipe } from "@angular/common";

import { DataTablesModule } from "angular-datatables";

import { AppRoutingModule, routingComponents } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { NavigationComponent } from "./navigation/navigation.component";

import { NgScrollbarModule } from "ngx-scrollbar";
import { HttpAuthInterceptor } from "./http-auth-interceptor";
import { AuthService } from "./servicios/auth.service";
import { DynamicFormComponent } from "./dynamic-form/dynamic-form.component";
import { DynamicFormContenidoComponent } from "./dynamic-form-contenido/dynamic-form-contenido.component";

import { PipesModule } from "src/app/modules/pipes/pipes.module";

import { UsuarioComponent } from "./components/usuario/usuario.component";
import { MglTimelineModule } from "angular-mgl-timeline";
import { InformeRecorridoVendedorComponent } from "src/app/components/informe-recorrido-vendedor/informe-recorrido-vendedor.component";

import { ScrollingModule } from "@angular/cdk/scrolling";

import {
  MAT_DATE_LOCALE,
  DateAdapter,
  MAT_DATE_FORMATS,
} from "@angular/material/core";

import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

import { ModificausuarioComponent } from "./components/modificausuario/modificausuario.component";
import { DynamicReportComponent } from "./dynamic-report/dynamic-report.component";
import { DynamicReportContenidoComponent } from "./dynamic-report-contenido/dynamic-report-contenido.component";
import { AsignacionServiciosComponent } from "./components/asignacion-servicios/asignacion-servicios.component";
import { ServiciosasignadosComponent } from "./components/serviciosasignados/serviciosasignados.component";
import { AdministracionConductoresComponent } from "./components/administracion-conductores/administracion-conductores.component";
import { AdministracionCausalesNoEntregaComponent } from "./components/administracion-causales-no-entrega/administracion-causales-no-entrega.component";
import { AdministracionMotivoDevolucionComponent } from "./components/administracion-motivo-devolucion/administracion-motivo-devolucion.component";
import { AdministracionEmpresaTransporteComponent } from "./components/administracion-empresa-transporte/administracion-empresa-transporte.component";
import { AdministracionUsuarioWebComponent } from "./components/administracion-usuario-web/administracion-usuario-web.component";
import { AdministracionMensajesComponent } from "./components/administracion-mensajes/administracion-mensajes.component";
import { EntregasCompletasComponent } from "./components/entregas-completas/entregas-completas.component";
import { EntregasParcialesComponent } from "./components/entregas-parciales/entregas-parciales.component";
import { EntregasComponent } from "./components/entregas/entregas.component";
import { TiemposRutasComponent } from "./components/tiempos-rutas/tiempos-rutas.component";
import { RutaEntregasComponent } from "./components/ruta-entregas/ruta-entregas.component";
import { UbicacionComponent } from "./components/ubicacion/ubicacion.component";
import { DialogEditPersonaComponent } from "./dialogs/dialog-edit-persona/dialog-edit-persona.component";

import { DialogCopiarEncuestaComponent } from "./dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component";
import { ServicioComponent } from "./components/servicio/servicio.component";
import { CrearServicioComponent } from "./components/servicio/crear-servicio/crear-servicio.component";
import { ModificarServicioComponent } from "./components/servicio/modificar-servicio/modificar-servicio.component";
import { CreacionPaqueteComponent } from "./components/servicio/creacion-paquete/creacion-paquete.component";
import { ModificarPaqueteComponent } from "./components/servicio/modificar-paquete/modificar-paquete.component";
import { from } from "rxjs";
import { DialogDocumentoComponent } from "./dialogs/dialog-documento/dialog-documento.component";
import { DialogProductoComponent } from "./dialogs/dialog-producto/dialog-producto.component";
import { DialogFirmaComponent } from "./dialogs/dialog-firma/dialog-firma.component";
import { DialogWebServiceComponent } from "./dialogs/dialog-web-service/dialog-web-service.component";

import { VerticalTimelineModule } from "angular-vertical-timeline";

import { AsignacionTransportadorAgenciaComponent } from "./components/asignacion-transportador-agencia/asignacion-transportador-agencia.component";
import { AsignacionTransportadorVehiculoComponent } from "./components/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component";
import { AdministracionTiposNovedadesComponent } from "./components/administracion-tipos-novedades/administracion-tipos-novedades.component";
import { AdministracionMotivosComponent } from "./components/administracion-motivos/administracion-motivos.component";
import { MotivosComponent } from "./components/administracion-motivos/motivos/motivos.component";
import { TipoMotivoComponent } from "./components/administracion-motivos/tipo-motivo/tipo-motivo.component";
import { TipoMotivoClasComponent } from "./components/administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component";
import { DialogAgenciasComponent } from "./dialogs/dialog-agencias/dialog-agencias.component";

import { AdministracionClientesNuevosComponent } from "./components/administracion-clientes-nuevos/administracion-clientes-nuevos.component";

import { InformeClientesComponent } from "./components/informe-clientes/informe-clientes.component";
import { InformeHabeasDataComponent } from "./components/informe-habeas-data/informe-habeas-data.component";

import { InformeUnidadesClienteComponent } from "./components/informe-unidades-cliente/informe-unidades-cliente.component";

import { InformeInicioGestionComponent } from "./components/informe-inicio-gestion/informe-inicio-gestion.component";

import { DialogRuteroComponent } from "./dialogs/dialog-rutero/dialog-rutero.component";
import { OrderModule } from "ngx-order-pipe";
import { DialogDetallePedidoComponent } from "./dialogs/dialog-detalle-pedido/dialog-detalle-pedido.component";

import { InformeOrdenesPedidoComponent } from "./components/informe-ordenes-pedido/informe-ordenes-pedido.component";
import { DialogBusquedaPersonaComponent } from "./dialogs/dialog-busqueda-persona/dialog-busqueda-persona.component";

import { DialogSelectItemComponent } from "./dialogs/dialog-select-item/dialog-select-item.component";

import { DialogOrdenLiquidacionComponent } from "./dialogs/dialog-orden-liquidacion/dialog-orden-liquidacion.component";

import { DialogDetallePickingComponent } from "./dialogs/dialog-detalle-picking/dialog-detalle-picking.component";

import { DialogAlertComponent } from "./dialogs/dialog-alert/dialog-alert.component";
import { DialogConfirmationComponent } from "./dialogs/dialog-alert-confirmation/dialog-confirmation.component";
import { DialogAlertTextComponent } from "./dialogs/dialog-alert-text/dialog-alert-text.component";

import { ModificarDireccionPersonaComponent } from "src/app/components/creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component";
import { ModificarUsuarioPersonaComponent } from "src/app/components/creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component";
import { DialogAsignacionPickingComponent } from "./dialogs/dialog-asignacion-picking/dialog-asignacion-picking.component";
import { DialogBusquedaEmpresaSucursalComponent } from "./dialogs/dialog-busqueda-empresa-sucursal/dialog-busqueda-empresa-sucursal.component";
import { DialogBusquedaProductoComponent } from "./dialogs/dialog-busqueda-producto/dialog-busqueda-producto.component";
import { DialogDetallePedidoGmlComponent } from "./dialogs/dialog-detalle-pedido-gml/dialog-detalle-pedido-gml.component";
import { DialogAutorizacionPedidosComponent } from "./dialogs/dialog-autorizacion-pedidos/dialog-autorizacion-pedidos.component";
import { DialogDetalleCarteraComponent } from "./dialogs/dialog-detalle-cartera/dialog-detalle-cartera.component";
@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    routingComponents,
    DynamicFormComponent,
    DynamicFormContenidoComponent,
    UsuarioComponent,
    ModificausuarioComponent,
    DynamicReportComponent,
    DynamicReportContenidoComponent,
    AsignacionServiciosComponent,
    ServiciosasignadosComponent,
    AdministracionConductoresComponent,
    AdministracionCausalesNoEntregaComponent,
    AdministracionMotivoDevolucionComponent,
    AdministracionEmpresaTransporteComponent,
    AdministracionUsuarioWebComponent,
    AdministracionMensajesComponent,
    EntregasCompletasComponent,
    EntregasParcialesComponent,
    EntregasComponent,
    TiemposRutasComponent,
    RutaEntregasComponent,
    UbicacionComponent,
    DialogEditPersonaComponent,
    DialogCopiarEncuestaComponent,
    ServicioComponent,
    CrearServicioComponent,
    ModificarServicioComponent,
    CreacionPaqueteComponent,
    ModificarPaqueteComponent,
    DialogDocumentoComponent,
    DialogProductoComponent,
    DialogFirmaComponent,
    DialogWebServiceComponent,
    AsignacionTransportadorAgenciaComponent,
    AsignacionTransportadorVehiculoComponent,
    AdministracionTiposNovedadesComponent,
    AdministracionMotivosComponent,
    MotivosComponent,
    TipoMotivoComponent,
    TipoMotivoClasComponent,
    DialogAgenciasComponent,
    AdministracionClientesNuevosComponent,
    InformeClientesComponent,
    InformeHabeasDataComponent,
    InformeUnidadesClienteComponent,
    InformeInicioGestionComponent,
    DialogRuteroComponent,
    DialogDetallePedidoComponent,
    InformeOrdenesPedidoComponent,
    DialogBusquedaPersonaComponent,
    DialogSelectItemComponent,
    DialogOrdenLiquidacionComponent,
    DialogDetallePickingComponent,
    InformeRecorridoVendedorComponent,
    DialogAlertComponent,
    DialogConfirmationComponent,
    DialogAlertTextComponent,
    ModificarDireccionPersonaComponent,
    ModificarUsuarioPersonaComponent,
    DialogAsignacionPickingComponent,
    DialogBusquedaEmpresaSucursalComponent,
    DialogBusquedaProductoComponent,
    DialogDetallePedidoGmlComponent,
    DialogAutorizacionPedidosComponent,
    DialogDetalleCarteraComponent,

  ],
  /*entryComponents: [
    DialogEditPersonaComponent,
    DialogCopiarEncuestaComponent,
    DialogDocumentoComponent,
    DialogWebServiceComponent,
    DialogAgenciasComponent,
    DialogRuteroComponent,
    DialogDetallePedidoComponent,
    DialogBusquedaPersonaComponent,
    DialogSelectItemComponent,
    DialogOrdenLiquidacionComponent,
    DialogDetallePickingComponent,
    DialogDashboardComponent,
  ],*/
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    CustomMaterialModule,
    ReactiveFormsModule,
    HttpClientModule,
    DataTablesModule,
    NgScrollbarModule,
    VerticalTimelineModule,
    OrderModule,
    MglTimelineModule,
    PipesModule,
    AppRoutingModule,
    PerfectScrollbarModule,
    ScrollingModule,
  ],
  exports: [PipesModule],
  providers: [
    AuthService,
    CurrencyPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptor,
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: "es-CO" },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
